export default {
  get_all: { method: "get", url: "api/strategic-plans" },
  show: { method: "get", url: "api/strategic-plans{/id}" },
  get_actions: { method: "get", url: "api/strategic-plans/get-actions{/id}" },
  store: { method: "post", url: "api/strategic-plans" },
  update: { method: "put", url: "api/strategic-plans{/id}" },
  delete: { method: "delete", url: "api/strategic-plans{/id}" },
  tree_plan_structure: {
    method: "get",
    url: "api/plan-structures/tree-plan-structure{/id}"
  },
  save_structure: {
    method: "post",
    url: "api/strategic-plans/save-structure{/id}"
  },
  orderStrategicPlansById: {
    method: "post",
    url: "api/strategic-plans/order"
  },
  orderPlanStructuresById: {
    method: "post",
    url: "api/plan-structures/order{/id}"
  },
  store_plan_structure: {
    method: "post",
    url: "api/plan-structures"
  },
  update_plan_structure: {
    method: "put",
    url: "api/plan-structures{/id}"
  },
  delete_plan_structure: {
    method: "delete",
    url: "api/plan-structures{/id}"
  },
  plan_structure_detail: {
    method: "get",
    url: "api/plan-structures{/id}/detail"
  },
  plan_structure_indicators: {
    method: "get",
    url: "api/plan-structures{/id}/indicators"
  },
  plan_structure_measures: {
    method: "get",
    url: "api/plan-structures{/id}/measures"
  },
  plan_structure_ods: {
    method: "get",
    url: "api/plan-structures{/id}/ods"
  },
  plan_structure_sync_ods: {
    method: "post",
    url: "api/plan-structures{/id}/ods"
  },
  plan_structure_update_full: {
    method: "put",
    url: "api/plan-structures{/id}/full"
  },
  plan_structure_store_action: {
    method: "post",
    url: "api/plan-structures{/id}/actions"
  },
  plan_structure_delete_action: {
    method: "delete",
    url: "api/plan-structures{/planStructureId}/actions{/actionId}"
  },
  plan_structure_order_measures: {
    method: "post",
    url: "api/plan-structures{/id}/measures/order"
  }
};
